// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfilePicture_container__3FUdq","small":"ProfilePicture_small__2rQar","normal":"ProfilePicture_normal__2693V","avatar":"ProfilePicture_avatar__ysjHa"};